module.exports = ".modal-dialog {\n    width: 1020px !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/migracao-fta-modal/migracao-fta-modal.component.css
// module id = ./src/app/modal/migracao-fta-modal/migracao-fta-modal.component.css
// module chunks = main